
import React from 'react';
import { 
  ChefHat, 
  Calendar, 
  MessageSquare, 
  ShoppingCart,
  Activity,
  Edit,
  StickyNote
} from 'lucide-react';

interface ActivityIconProps {
  activityType: string;
}

const ActivityIcon: React.FC<ActivityIconProps> = ({ activityType }) => {
  const getIcon = () => {
    switch (activityType) {
      case 'recipe_created':
        return <ChefHat className="h-5 w-5 text-green-600" />;
      case 'recipe_updated':
        return <Edit className="h-5 w-5 text-blue-600" />;
      case 'meal_planned':
      case 'meal_updated':
        return <Calendar className="h-5 w-5 text-purple-600" />;
      case 'feedback_added':
        return <MessageSquare className="h-5 w-5 text-orange-600" />;
      case 'shopping_list_generated':
        return <ShoppingCart className="h-5 w-5 text-indigo-600" />;
      case 'wellness_report_generated':
        return <Activity className="h-5 w-5 text-teal-600" />;
      case 'note_created':
      case 'note_updated':
      case 'note_deleted':
        return <StickyNote className="h-5 w-5 text-yellow-600" />;
      default:
        return <ChefHat className="h-5 w-5 text-gray-600" />;
    }
  };

  return (
    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
      {getIcon()}
    </div>
  );
};

export default ActivityIcon;
